var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('crud-form',_vm._b({on:{"submitForm":_vm.submitForm,"reset":_vm.reset}},'crud-form',_vm.formPropsExtra,false))}
var staticRenderFns = []

export { render, staticRenderFns }